import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import Theme from './Theme';
import VersionBadge from './components/VersionBadge';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <Theme>
      <App />
      <VersionBadge />
    </Theme>
  </StrictMode>
);
